import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { LaundryItemApi } from '../api/laundryitem.api';
import { switchMap, map } from 'rxjs/operators';

import { LaundryItemData, LaundryItem } from '../../../interfaces/masters/laundryitem' ;
@Injectable()
export class LaundryItemService extends LaundryItemData {

    constructor(private api: LaundryItemApi) {
      super();
    }
  
  
    list(url: string): Observable<LaundryItem[]> {
      return this.api.list(url);
    }
  
    getById(url:string): Observable<LaundryItem>{
        return this.api.getById(url);
    }
  
    create(url: string, data:LaundryItem): Observable<LaundryItem[]> {
      return this.api.add(url,data);
    }
  
    update(url: string, data:LaundryItem): Observable<LaundryItem> {
      return this.api.update(url,data);
    }
  
    
  
    delete(url: string): Observable<boolean> {
      return this.api.delete(url);
    }
  }
  